var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { ERentioFormField } from "../../components/components/Form";
import { getLocalizedText } from "../../utils/i18n/i18n.utils";
import { EField } from "./schema.createPayment.types";
import { customContactsSelector, customContactsValueSelector, getCreatePaymentCompanyFieldsSchema, getCreatePaymentContactFieldsSchema, getDefaultPayerPayeeValue, getNavigationTitle, getRelatedContract, getSubtitle, isAllowedCostPayer, } from "./schema.createPayment.utils";
import { customGetContactsActions, customIsFetchingSelector, } from "./schema.createPayment.utils.fetchContacts";
// Who a cost payment may bill, when its embedder says (see
// IPaymentPrefill.payerAccountIds). Undefined = anyone.
var getCostPayerAccountIds = function (extraData) {
    var _a;
    return ((_a = extraData.prefill) === null || _a === void 0 ? void 0 : _a.costPayment)
        ? extraData.prefill.payerAccountIds
        : undefined;
};
export var getSchema = function (initialValues, extraData) {
    return function (defaultValues) {
        var _a, _b;
        var _c, _d;
        var contract = getRelatedContract(extraData, defaultValues);
        // Cost flow: the embedding wizard already renders its own step title, so
        // skip the section header to avoid stacking three headings.
        var isCostPayment = !!((_c = extraData.prefill) === null || _c === void 0 ? void 0 : _c.costPayment);
        return {
            required: [EField.Payer],
            properties: __assign(__assign({}, (isCostPayment
                ? {}
                : (_a = {},
                    _a[EField.Header4] = {
                        default: undefined,
                    },
                    _a))), (_b = {}, _b[EField.Payer] = {
                default: getDefaultPayerPayeeValue({
                    key: EField.Payer,
                    initialValues: initialValues,
                    defaultValues: defaultValues,
                    type: defaultValues[EField.TypeRecurring] ||
                        defaultValues[EField.TypeOnce],
                    contract: contract,
                    costPayment: !!((_d = extraData.prefill) === null || _d === void 0 ? void 0 : _d.costPayment),
                }),
            }, _b)),
        };
    };
};
// A cost payment only bills someone its cost can hold as payer: refused
// here, before the order exists, instead of by the cost's save after it.
export var getValidate = function (extraData) { return function (formData, errors) {
    var _a;
    var payerAccountIds = getCostPayerAccountIds(extraData);
    var payerIds = Array.isArray(formData[EField.Payer])
        ? formData[EField.Payer]
        : [];
    var hasRefusedPayer = payerIds.some(function (accountId) { return !isAllowedCostPayer({ payerAccountIds: payerAccountIds, accountId: accountId }); });
    if (hasRefusedPayer) {
        (_a = errors[EField.Payer]) === null || _a === void 0 ? void 0 : _a.addError(getLocalizedText("costs.payment.payer_not_on_lease"));
    }
    return errors;
}; };
export var uiSchema = function (extraData) {
    var _a, _b;
    var _c, _d;
    return (__assign(__assign({ "rentio:title": getLocalizedText("payments.create.payer.heading.summary"), "rentio:navigationTitle": getNavigationTitle(extraData), "rentio:summaryTitle": getLocalizedText("payment.payment_order.payer") }, (((_c = extraData.prefill) === null || _c === void 0 ? void 0 : _c.costPayment)
        ? {}
        : (_a = {},
            _a[EField.Header4] = {
                "ui:field": ERentioFormField.SectionHeader,
                getTitle: function (formData) {
                    return getLocalizedText("payments.create.payer.heading", {
                        type: formData.otherDescription ||
                            getLocalizedText("payment.payment_order.type.".concat(formData.typeRecurring || formData.typeOnce).toLowerCase()),
                    });
                },
            },
            _a))), (_b = {}, _b[EField.Payer] = {
        "ui:field": ERentioFormField.ContactSelectInlineV2,
        getTitle: function (formData) {
            return getLocalizedText("payment.payment_order.payer.heading", {
                type: formData.otherDescription ||
                    getLocalizedText("payment.payment_order.type.".concat(formData.typeRecurring || formData.typeOnce).toLowerCase()),
            });
        },
        selectContactFromListCtaTitle: getLocalizedText("payment.payment_order.payer.select_other.cta"),
        // A cost payment whose embedder names who may pay lists all of them: no
        // other contact to pick, the cost could not bill them.
        addCtaLabel: getCostPayerAccountIds(extraData)
            ? undefined
            : getLocalizedText("payment.payment_order.payer.other.label"),
        info: ((_d = getCostPayerAccountIds(extraData)) === null || _d === void 0 ? void 0 : _d.length) === 0
            ? getLocalizedText("costs.modal.no_tenants_to_collect")
            : undefined,
        isMultiSelect: false,
        asOptionList: true,
        getRequiredContactFieldsSchema: getCreatePaymentContactFieldsSchema,
        getRequiredCompanyFieldsSchema: getCreatePaymentCompanyFieldsSchema,
        withSummaryValidation: false,
        // Custom selectors & actions
        valueSelector: function (state, selectedAccountIds) {
            return customContactsValueSelector({
                state: state,
                propertyId: extraData.property.id,
                selectedAccountIds: selectedAccountIds,
            });
        },
        customGetSubtitleSelector: function (state, formData, item) {
            return getSubtitle({
                state: state,
                contract: getRelatedContract(extraData, formData),
                propertyId: extraData.property.id,
                item: item,
            });
        },
        customExtraAccountsSelector: function (state, formData) {
            var _a;
            if (formData === void 0) { formData = {}; }
            return customContactsSelector({
                type: formData[EField.TypeRecurring] || formData[EField.TypeOnce],
                formData: formData,
                payerType: "payer",
                state: state,
                contract: getRelatedContract(extraData, formData),
                costPayment: !!((_a = extraData.prefill) === null || _a === void 0 ? void 0 : _a.costPayment),
                propertyId: extraData.property.id,
                payerAccountIds: getCostPayerAccountIds(extraData),
            });
        },
        customIsFetchingSelector: function (state) {
            return customIsFetchingSelector(state, extraData);
        },
        customGetContactsActions: customGetContactsActions(extraData),
    }, _b)));
};
